const initialState = {
    error: null,
    fetched: false,
    fetching: false,
};

const actions = {
    CHANGE_PASSWORD_FETCH: (state) => ({...state, fetching: true, error: null}),

    CHANGE_PASSWORD_FETCH_FULFILLED: (state, {payload}) => ({...state, ...payload}),

    CHANGE_PASSWORD_FETCH_REJECTED: (state, {payload}) => ({...state, ...payload}),

    CHANGE_PASSWORD_CLEAR_ERROR: (state) => ({...state, error: null, fetching: false}),

    CHANGE_PASSWORD_RESET: () => ({...initialState}),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
